
(function () {
  function hideTechnicalIDs() {
    document.querySelectorAll(
      '.cart_content .mini-cart__item-property, .cart_content .line-item'
    ).forEach(function (element) {
      if (/^\s*_?wgsRefIDv2\s*:/i.test(element.textContent.trim())) {
        element.remove();
      }
    });
  }

  function init() {
    var cart = document.querySelector('.cart_content');
    if (!cart) return;

    hideTechnicalIDs();

    var observer = new MutationObserver(hideTechnicalIDs);
    observer.observe(cart, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
